module.exports = __webpack_public_path__ + "img/activities-2.c7f7d446.jpg";